import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Container, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import FileUploader from "../../citizen/AVPForms/reusableComponents/FileUploader2";
import KmlFileUploader from "../../citizen/TCPForms/reusableComponents/KmlFileUploader";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import { useTranslation } from "react-i18next";
import { TypeOfLetter } from "../../citizen/TCPForms/data";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
import useEmpMapSubmission from "../MapSubmission/useEmpMapSubmission";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";


const CustomLetter = ({ formData, setCustomLetter ,setTypeOfLetter, workflowDetails, userRolesArray, 
  iframeSrc, setIframeSrc, initialUrl, setIsPreviewLoading
}) => {
  const { t } = useTranslation();
  const { documents } = useSelector((state) => state.formMT);
  const [showError, setShowError] = useState(false);
  const [isLetterAttached, setIsLetterAttached] = useState(false);
  const [dataOfCustomLetter, setDataOfCustomLetter] = useState([]);
  console.log("documentFromRedux", documents);
  console.log("documentsectionRendered");
  // const tenantId = Digit.ULBService.getCurrentTenantId();
  //  const {
  //     handleChange,
  //     currentTab,
  //     tabList,
  //     currentAction,
  //     onRadioActionSelect,
  //     Modal,
  //     actions,
  //     error,
  //     setError,
  //     updatedDocuments,
  //     setUpdatedDocuments,
  //     isCitizen,
  //     isEE,
  //     isDa,
  //     remarks,
  //     setRemarks,
  //     getTabIndex,
  //     taxHead,
  //     setTaxHead,
  //     documentSection,
  //     isPreviewLoading,
  //     setIsPreviewLoading,
  //     iframeSrc,
  //     setIframeSrc,
  //     handleDocView,
  //     currentView,
  //     setCurrentView,
  //     initialUrl,
  //     developerRemarks,
  //     setDeveloperRemarks,
  //     drawingPdfs,
  //     initialPdfUrl,
  //     pdfIframeSrc,
  //     setPdfIframeSrc
  //   } = useEmpMapSubmission(formData, workflowDetails, userRolesArray);

  // const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);

  useEffect(() => {
        const dataOFCustomLetter= formData?.documents?.filter((doc)=>["typeOfLetterDoc"].includes(doc.documentType))
        if(dataOFCustomLetter.length>0){
          setIsLetterAttached(true);
          setDataOfCustomLetter(dataOFCustomLetter);
        }
  },[formData, isLetterAttached, dataOfCustomLetter]);

  // const validateFiles = () => {
  //   const uploadedDocs = new Set(documents?.map((doc) => doc.documentType)); // Using Set for faster lookups
  //   const requiredDocs =
  //     formData?.descriptionOfLand?.schemeType === "Scheme"
  //       ? ["completeDrawingFile", "landOwnershipDoc", "kmlFile", "allotmentLetter", "possessionLetter", "registrySaleDeedHPTA"]
  //       : [
  //           "completeDrawingFile",
  //           "landOwnershipDoc",
  //           "kmlFile",
  //           "developerConsortiumSalesAgreement",
  //           "khatauni",
  //           "registrySaleDeedHPTA",
  //           "mutationLetter",
  //         ];

  //   return requiredDocs.every((doc) => uploadedDocs.has(doc)); // Use Set.has for O(1) lookup
  // };

  const defaultValues = {
    ...formData,
    documents: documents,
  };
  // const isSchemeType = formData?.descriptionOfLand?.schemeType === "Scheme";
  const { handleSubmit, control, reset, setValue, getValues } = useForm({ defaultValues });
  const handleFormSubmit = (data) => {
      console.log("submitIf", data);
      onSubmit(data);
  };

  const onSubmit = (data) => {
    setCustomLetter(documents);
    setTypeOfLetter(data?.customLetter);
  };

  console.log("dataofcustomletter",formData)
  return (
    <section className="groupContainer2">
      { !isLetterAttached && <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Attachment Letter")}</h2>
          </div>

          <Container className="formInputContainer" fluid>
            <Row>
            <Col>
            <InputWrapper
                  control={control}
                  data={SortingAlphabatically(TypeOfLetter)}
                  label={t("Custom Letter")}
                  name="customLetter"
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
                </Col>
              <Col>
                <FileUploader
                  isMandatory
                  // hasLabel={false}
                  control={control}
                  name="typeOfLetterDoc"
                  label="Type Of Letter Doc"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                  showError={showError}
                  tab={4}
                  maxFiles={1}
                />
              </Col>
            </Row>
          </Container>
          <div className="footerContainer2">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3", marginRight: "4px" }}
              />
            </div>
          </div>
        </div>
      </form>}
      {
        isLetterAttached && ( userRolesArray?.[0]?.code !== "JE") && <ViewDocuments 
              documentSection={dataOfCustomLetter}
              setCustomLetter={setCustomLetter}
              setTypeOfLetter={setTypeOfLetter}
              setIsPreviewLoading={setIsPreviewLoading}
              iframeSrc={iframeSrc}
              setIframeSrc={setIframeSrc}
              initialUrl={initialUrl}
        />
      }
    </section>
  );
};

export default CustomLetter;
